export const MAX_WIDTH = 800; //window.innerWidth; //600;
export const MAX_HEIGHT = 800; //window.innerHeight; //800;
export const HALF_SCREEN_WIDTH = MAX_WIDTH / 2;
export const HALF_SCREEN_HEIGHT = MAX_HEIGHT / 2;
